import { Alert, Drawer, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBarcode,
  faFloppyDisk,
  faGear,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SelectMulti } from '../../../../../Components/CustomUi/SelectMulti'
import { NavegacaoDrawer } from '../../../../app/recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import TextArea from '../../../../../Components/CustomUi/textarea'
import { Render } from '../../../../../Components/CustomUi/render'
import Carregando from '../../../../../Components/CustomUi/loading'
import Checkbox from '../../../../../Components/CustomUi/checkbox'
import { Box } from '../../../../../Components/CustomUi/box'
import Input from '../../../../../Components/CustomUi/input'

interface PropsFormulario {
  open: boolean
  fecharGaveta: Function
  update: number
  usuarios_selecionados: { descr: string; id: number; key?: number }[]
  setUsuarios_selecionados: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  descricao: string
  setDescricao: React.Dispatch<React.SetStateAction<string>>
  comando: string
  setComando: React.Dispatch<React.SetStateAction<string>>
  tipo: string
  setTipo: React.Dispatch<React.SetStateAction<string>>
  setTipoId: React.Dispatch<React.SetStateAction<number>>
  cod_aplicativo: string
  setCod_aplicativo: React.Dispatch<React.SetStateAction<string>>
  data_usuario: any[]
  log: string
  cadastrarComando: Function
  loadingSalvar: boolean
  loadingForm: boolean
}

export const FormularioComando: React.FC<PropsFormulario> = ({
  open,
  fecharGaveta,
  update,
  descricao,
  setDescricao,
  usuarios_selecionados,
  setUsuarios_selecionados,
  comando,
  setComando,
  tipo,
  setTipo,
  setTipoId,
  cod_aplicativo,
  setCod_aplicativo,
  data_usuario,
  log,
  cadastrarComando,
  loadingSalvar,
  loadingForm,
}) => {
  const [openUsers, setOpenUsers] = useState<boolean>(false)
  const [openTipo, setOpenTipo] = useState<boolean>(false)

  const dataTipo = [
    {
      cod: 1,
      nome: 'No login',
    },
    {
      cod: 2,
      nome: 'Na sincronização',
    },
    {
      cod: 3,
      nome: 'Ao finalizar',
    },
  ]

  return (
    <Drawer
      width={500}
      open={open}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      footer={
        <div className='footer'>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            type='primary'
            onClick={cadastrarComando}
            loading={loadingSalvar}
          >
            Salvar
          </ButtonCustom>
        </div>
      }
      title={
        <NavegacaoDrawer>
          <ButtonCustom
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
            type='tertiary'
            onClick={fecharGaveta}
            style={{ marginLeft: -10 }}
          >
            Fechar
          </ButtonCustom>
        </NavegacaoDrawer>
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '10px',
          boxSizing: 'border-box',
          gap: 10,
        }}
      >
        <Render condition={loadingForm === false}>
          <SelectMulti
            label='Usuários'
            placeholder='Seleciones os usuários'
            icon={faUsers}
            open={openUsers}
            trigger={setOpenUsers}
            items={data_usuario}
            descricaoItem={'nome'}
            idItem={'cod'}
            selecteds={usuarios_selecionados}
            onChange={setUsuarios_selecionados}
          />
          <Select
            label='Opções ao executar'
            placeholder='Selecionar opção ao executar'
            icon={faGear}
            value={tipo}
            onChange={setTipo}
            onChangeID={setTipoId}
            open={openTipo}
            trigger={setOpenTipo}
            items={dataTipo}
            descricaoItem={'nome'}
            idItem={'cod'}
            disabled={update > 0}
          />
          <Render condition={cod_aplicativo !== null}>
            <Input
              label='Código do aplicativo'
              icon={faBarcode}
              placeholder={''}
              value={cod_aplicativo}
              onChange={setCod_aplicativo}
              desabilitado={update > 0}
            />
          </Render>
          <TextArea label='Descrição' value={descricao} onChange={setDescricao} />
          <TextArea label='Comando' value={comando} onChange={setComando} disabled={update > 0} />
          <Render condition={log !== null}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={{ fontWeight: 500, fontSize: '13px', marginBottom: '5px' }}>Log</label>
              <div
                style={{
                  border: '1px solid #d9d9d9',
                  borderRadius: '7px',
                  padding: '10px',
                  height: '100px',
                  overflowY: 'auto',
                }}
              >
                {log}
              </div>
            </div>
          </Render>
        </Render>
        <Render condition={loadingForm}>
          <Carregando
            animation
            justifyContent='center'
            legenda='Carregando...'
            size='default'
            height={650}
          />
        </Render>
      </div>
    </Drawer>
  )
}